// extracted by mini-css-extract-plugin
module.exports = {"description":"ProductGallery_description__1aJwH","gallery":"ProductGallery_gallery__6HrMV","swiperTool":"ProductGallery_swiperTool__I4k3H"};